import { createContext, useContext } from 'react';

const Context = createContext(null);

export const PopupProvider = Context.Provider;
export const usePopupState = () => useContext(Context);
